.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .nav {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding: 2rem 6rem;

    @media (--md-down) {
      padding-inline: 2rem;
    }

    .nav__inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: var(--site-content-max-width);
      margin: 0 auto;

      .nav__inner__buttons {
        display: flex;
        gap: 1rem;
        align-items: center;
      }
    }
  }

  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2.125rem;
    align-items: center;
    justify-content: center;
    padding: 10rem 6rem;
    background:
      url("@/assets/images/artsy-blob-pink-full.png") no-repeat top -500px
        right -500px,
      url("@/assets/images/artsy-blob-pink-full.png") no-repeat bottom -500px
        left -500px;

    @media (--md-down) {
      padding-inline: 2rem;
      background: none;
    }
  }

  .cta {
    background-color: var(--pink-200);

    .cta__content {
      display: flex;
      flex-direction: column;
      gap: 2.875rem;
      align-items: center;
      max-width: var(--site-content-max-width);
      padding: 5.75rem;
      margin: 0 auto;

      @media (--md-down) {
        padding-inline: 2rem;
      }

      .cta__content__header {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
        align-items: center;

        .cta__content__title {
          margin: 0;
          font-size: var(--font-size-h1-large);
          font-weight: var(--font-weight-regular);
          text-align: center;
          text-wrap: balance;

          @media (--md-down) {
            font-size: var(--font-size-h1-large-phone);
          }
        }

        .cta__content__subtitle {
          margin: 0;
          font-size: var(--font-size-h3);
          font-weight: var(--font-weight-light);
          text-align: center;
          text-wrap: balance;

          @media (--md-down) {
            font-size: var(--font-size-h3-phone);
          }
        }
      }

      .cta__content__buttons {
        display: flex;
        gap: 1rem;
        align-items: center;
      }
    }
  }

  .footer {
    background-color: var(--purple);

    .footer__content {
      display: flex;
      gap: 2.5rem;
      align-items: center;
      justify-content: space-between;
      max-width: var(--site-content-max-width);
      padding-block: 3.5rem;
      margin: 0 auto;

      @media (--md-down) {
        flex-direction: column;
        gap: 1.5rem;
        padding-inline: 2rem;
      }

      .footer__content__link {
        font-size: var(--font-size-subtitle-2);
        font-weight: var(--font-weight-regular);
        color: var(--blue-400);
      }
    }
  }
}
